import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6484c492"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/app/app-main.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "@/assets/styles/basic/animations.less?vue&type=style&index=1&prod&lang=less&external"
import style2 from "@/assets/styles/basic/vuetify/index.less?vue&type=style&index=2&prod&lang=less&external"
import style3 from "@/assets/styles/basic/item-card.less?vue&type=style&index=3&prod&lang=less&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports